import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { initiateTransporterCreate, initiateTransporterEdit, setNewTransporterValue } from '../../actions';
import { selectNewTransporter, selectTransporter } from '../../selectors';

import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { selectConfig, selectWorks } from '../../../Api/selectors';
import { REQUEST_TRANSPORTER } from '../../constants';

import cn from 'classnames';
import { CreateTransporterModal } from './CreateTransporterModal';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';

const STATE = {
  showCreateModal: false,
};

class TransporterCreateModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  reset() {}

  save(callback, saveStrategy) {}

  render() {
    if (this.props.work) {
      return (
        <ModalComponent size={'modal-lg'}>
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
        </ModalComponent>
      );
    }

    return (
      <>
        {this.state.showCreateModal && (
          <CreateTransporterModal
            onClose={() => this.setState({ showCreateModal: false })}
            transporterId={this.props.transporterId}
          />
        )}
        {window.innerWidth <= 768 && (
          <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftAdd'}>
            {' '}
            +
          </ButtonComponent>
        )}
        {window.innerWidth >= 768 && (
          <>
            <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftEdit'}>
              {' '}
              {this.props.transporterId ? this.lbl('edit') : this.lbl('vehicle.overview.addNewButton')}
            </ButtonComponent>
          </>
        )}
      </>
    );
  }
}

TransporterCreateModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_TRANSPORTER]),
    values: selectNewTransporter(),
    transporter: selectTransporter(ownProps?.transporterId),

    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateTransporterCreate());
    },
    initEdit() {
      dispatch(initiateTransporterEdit(ownProps.transporterId));
    },

    setValue(name, value) {
      dispatch(setNewTransporterValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransporterCreateModal = compose(withConnect, withRouter)(TransporterCreateModalComp);
